import {
  createThemeSelector,
  createVariableThemeSelectorCreator
} from './utils'

export const breakpointsSelector = createThemeSelector(
  theme => theme.breakpoints
)

export const getBreakpointUpSelector = createVariableThemeSelectorCreator(
  size =>
    createThemeSelector(breakpointsSelector, breakpoints =>
      breakpoints.up(size)
    )
)

export const getBreakpointDownSelector = createVariableThemeSelectorCreator(
  size =>
    createThemeSelector(breakpointsSelector, breakpoints =>
      breakpoints.down(size)
    )
)

export const getBreakpointCustomSelector = createVariableThemeSelectorCreator(
  name =>
    createThemeSelector(
      breakpointsSelector,
      breakpoints => breakpoints.custom[name]
    )
)

export const breakpointTabletSelector = getBreakpointUpSelector('sm')

export const breakpointBelowTabletSelector = getBreakpointDownSelector('sm')
export const breakpointAboveTabletSelector = getBreakpointUpSelector('md')

export const breakpointMobileLandscapeSelector = getBreakpointCustomSelector(
  'mobileLandscape'
)
